/*Activar menu fijo al llegar al elemento menu*/
$(document).ready(function () {
    $(document).foundation();
    InitCookiesBanner();
    InitTopicCtrl();
    InitUserMenu();
    InitLRPlusMenu();
    InitOutsideModal();
    GoToUrl();
    InitFormSubscriber();
    $(window).scroll(function () {
        var animationId;
        if ($(this).scrollTop() > 150) {
            HideTopMenuUser();
            HideTopMenuLRPlus();
            var y = 150 - $('.stickyHeader').height();
            var offsetSky = $(this).scrollTop() - y;
            var footerOffset = ($(this).scrollTop() + 155 + 600) - $(document).height() + $('.footer').height();
            //console.log(footerOffset);
            footerOffset = footerOffset > 0 ? footerOffset : 0;
            $('.leftSky, .rightSky').css("top", offsetSky - footerOffset);
            $('.stickyHeader').fadeIn(500);
        } else {
            HideStickyMenuUser();
            HideStickyMenuLRPlus();
            $('.leftSky, .rightSky').css("top", 0);
            $('.stickyHeader').fadeOut(500);
        }

        if ($(this).scrollTop() > 300 && $(this).scrollTop() < ($(document).height() - $(window).height() - 1200)) {
            $('.captionShare .sharePost').length ? $('.captionShare .sharePost').addClass('open') : null;
        } else {
            $('.captionShare .sharePost').length ? $('.captionShare .sharePost').removeClass('open') : null;
        }
    });
});

function InitTopicCtrl() {
    $(".btn-themes").click(function () {
        if ($(".tags-module.mobile").hasClass('show')) {
            $(".tags-module.mobile").removeClass('show');
        } else {
            $(".tags-module.mobile").addClass('show');
            if ($(".content-body ul").prop('scrollHeight') > $(".content-body ul").height()) {
                $(".content-body").addClass('overflow-tags');
            }
        }
    });
    $(".content-body p .close").click(function () {
        $(".tags-module.mobile").removeClass('show');
    });
}

function InitLRPlusMenu() {
    $(".menu-lr-mas").click(function (event) {
        HideTopMenuUser();
        HideStickyMenuUser();
        $(event.target).parents(".menu-lr-mas").children(".modal").show();
        $(".overlay").addClass("show");
        document.body.classList.add("overflow-hidden");
    });
}

function HideTopMenuLRPlus() {
    $(".desktopHeader .menu-lr-mas .modal").hide();
    $(".overlay").removeClass("show");
    document.body.classList.remove("overflow-hidden");
}

function HideStickyMenuLRPlus() {
    $(".stickyHeader .menu-lr-mas .modal").hide();
    $(".overlay").removeClass("show");
    document.body.classList.remove("overflow-hidden");
}

function InitUserMenu() {
    $(".user-name").click(function (event) {
        HideTopMenuLRPlus();
        HideStickyMenuLRPlus();
        $(event.target).parents(".user-name").children(".modal").show();
        $(".overlay").addClass("show");
        document.body.classList.add("overflow-hidden");
    });
}

function HideTopMenuUser() {
    $(".desktopHeader .user-name .modal").hide();
    $(".overlay").removeClass("show");
    document.body.classList.remove("overflow-hidden");
}

function HideStickyMenuUser() {
    $(".stickyHeader .user-name .modal").hide();
    $(".overlay").removeClass("show");
    document.body.classList.remove("overflow-hidden");
}

function InitOutsideModal() {
    $(document).click(function (event) {
        if (!$(event.target).parents(".menu-lr-mas, .user-name").length 
                || $(event.target).hasClass("overlay")
                || $(event.target).is( "a" )) {
            HideTopMenuLRPlus();
            HideStickyMenuLRPlus();
            HideTopMenuUser();
            HideStickyMenuUser();
        }
    });
}

function GoToUrl() {
    $(".gotourl").click(function (event) {
        window.location.href = $(this).data("gotoUrl");
    });
}

function InitFormSubscriber() {
    $(".modal form").click(function (event) {
        event.stopPropagation();
    });
    $(".activate-subscription").submit(function (event) {
        event.preventDefault();
        var tForm = $(this);
        var idNumber = tForm.find('input[name="identification"]').val();
        if (idNumber) {
            $.ajax({
                url: '/api/lrplus/subscribe',
                type: "POST",
                data: JSON.stringify({
                    identification: idNumber
                }),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function (d) {
                    if (d.success) {
                        setActivateSubsMsg($('.activatesubs-success-message'), "Cuenta activada de forma satisfactoria.", 3000);
                        $(".content-suscriptor").hide();
                    } else {
                        setActivateSubsMsg(tForm.find('span.error'), d.errorMessage, null);
                        _self.subscribeMessage = d.data.errorMessage;
                    }
                    renderSubsFormActivate();
                }
            });
        } else {
            setActivateSubsMsg(tForm.find('span.error'), "El número de identificación es obligatorio", 3000);
        }
    });
    renderSubsFormActivate();
}

function setActivateSubsMsg(errorBox, errorMsg, t) {
    errorBox.html(errorMsg);
    if (t) {
        setTimeout(() => {
            errorBox.html(null);
        }, t);
    }
}

function renderSubsFormActivate() {
    $.ajax({
        url: '/api/user/info',
        type: "POST",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (d) {
            if (d.isAuthenticated && !d.isSubscriber) {
                $('.activatesubs-box').show();
                if (!d.subscriberId) {
                    $('.activatesubs-box .without-activate').show();
                    $('.activatesubs-box .invalid-activation').hide();
                } else {
                    $('.activatesubs-box .without-activate').hide();
                    $('.activatesubs-box .invalid-activation').show();
                }
            }
        }
    });
}

function InitCookiesBanner() {
    var cookiesBanner = $(".cookies");
    var cookieRef = "LR_hacp=true";

    if (document.cookie.indexOf(cookieRef) < 0) {
        cookiesBanner.show();
    }

    $(".cookies .action").click(function () {
        document.cookie = cookieRef + "; max-age=31536000; samesite=strict";
        cookiesBanner.hide();
    });
}